export * from './Icon';
export { default as Icon } from './Icon';
